export default function InputRadio({
  id,
  label,
  answerOption,
  handleChange,
  errorMessage,
  register,
  disabled,
  isVerticalAlign,
  value,
  required,
  testId,
  standardQuestionName,
}) {
  return (
    <div className="inline-flex space-x-4">
      {label != undefined ? (
        <div
          className="questionnaire font-semibold max-w-[538px]"
          id={"question" + id}
        >
          {label}
        </div>
      ) : (
        ""
      )}

      <div
        id={id}
        className={
          isVerticalAlign ? "flex flex-col" : "flex flex-row items-center"
        }
        aria-labelledby={"question" + id}
      >
        {answerOption.map((option, i) => {
          const isOptionDisabled = disabled || option?.disabled;
          const radioClassName =
            (required ? "custom__radio Mandatory" : "custom__radio") +
            (isOptionDisabled ? " is-locked" : "");

          return (
            <span
              key={i}
              className={isVerticalAlign ? "custom__radio-wrapper column" : ""}
            >
              {value ? (
                <input
                  {...register}
                  id={option.id}
                  onChange={handleChange}
                  value={option.value}
                  className={radioClassName}
                  type="radio"
                  // name={option.name}
                  data-cy={testId + "_" + option.value}
                  aria-disabled={isOptionDisabled}
                  disabled={option?.disabled}
                  checked={value === option.value}
                  standardquestionname={standardQuestionName}
                />
              ) : (
                <input
                  {...register}
                  id={option.id}
                  onChange={handleChange}
                  value={option.value}
                  className={radioClassName}
                  type="radio"
                  // name={option.name}
                  data-cy={testId + "_" + option.value}
                  aria-disabled={isOptionDisabled}
                  disabled={option?.disabled}
                  standardquestionname={standardQuestionName}
                />
              )}
              <label htmlFor={option.id} className="inline-size">
                <span dangerouslySetInnerHTML={{ __html: option.label }} />
              </label>
            </span>
          );
        })}
        <span
          className="font-semibold text-secondary-red"
          data-cy="errorMessageRadio"
        >
          {errorMessage}
        </span>
      </div>
    </div>
  );
}
